//SCORE TOTAL Calcul Score Le Ray

      const scoreTotal = (score, calcul) => {
            let tot = score?.proba[calcul.proba] * Math.max(score?.impact[calcul.juridique] ? score?.impact[calcul.juridique] : 0, score?.impact[calcul.humain] ? score?.impact[calcul.humain] : 0, score?.impact[calcul.immateriel] ? score?.impact[calcul.immateriel] : 0, score?.impact[calcul.operationnel] ? score?.impact[calcul.operationnel] : 0, score?.impact[calcul.evenement] ? score?.impact[calcul.evenement] : 0, score?.impact[calcul.financier] ? score?.impact[calcul.financier] : 0)
            //console.log({tot})
            return tot
      }

    export default scoreTotal